import type { ReactNode } from 'react';

export const symbol_battery_share: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M429.5-290q-12.5 0-21-8.63-8.5-8.62-8.5-21.37v-90q0-24.75 17.25-42.38Q434.5-470 460-470h220l-52-52q-8-9.07-8-21.53 0-12.47 8.25-20.6 9-8.87 21.38-8.87 12.37 0 21.37 9l103 103q9 9.07 9 21.53 0 12.47-9 21.47L671-315q-9.07 9-21.53 9-12.47 0-21.47-9-9-9-9-21.5t9-21.5l53-52H460v91q0 12-9 20.5t-21.5 8.5ZM310-80q-12.75 0-21.37-8.63Q280-97.25 280-110v-676q0-12.75 8.63-21.38Q297.25-816 310-816h90v-34q0-12.75 8.63-21.38Q417.25-880 430-880h100q12.75 0 21.38 8.62Q560-862.75 560-850v34h90q12.75 0 21.38 8.62Q680-798.75 680-786v110q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-80H340v616h280v-64q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v94q0 12.75-8.62 21.37Q662.75-80 650-80H310Z"
		/>
	</svg>
);
